/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export class CollectionSortType {
    public static readonly BY_SEASON = 'seasonOrYearAsc';

    public static readonly BY_DATE = 'dateDesc';
}
